
import React from 'react'
export const Chip: React.FC<{label: string; tone?: 'info'|'success'|'warn'|'error'}> = ({label, tone='info'}) => {
  const toneMap = { info:'bg-blue-100 text-blue-800', success:'bg-green-100 text-green-800', warn:'bg-yellow-100 text-yellow-800', error:'bg-red-100 text-red-800' }
  return <span className={`px-2 py-0.5 rounded-full text-xs ${toneMap[tone]}`}>{label}</span>
}
